import { Component, ComponentRef } from '@angular/core';
import { MultiLanguageLinkConfig } from '@dch/products-business-logic/src/shared/models/config.model';
import {
  CustomerService,
  InceptionService,
  LanguageService,
  TranslationService,
} from '@proximus/ng-common';
import { ActivatedRoute, Router } from '@angular/router';
import {
  getPiiProduct,
  savePii,
  savePiiNsp,
} from '../../../../shared/pii/pii.utils';
import * as ProductsActions from '../../../../store/actions/products.actions';
import {
  Location,
  Pack,
  PlcCodes,
  Product,
} from '@dch/products-business-logic';
import { ModalService } from '@proximus/ng-common-components';
import { OnDestroyHookDirective } from 'src/app/shared/hooks';
import { Store } from '@ngrx/store';
import { ApplicationState, getUserProduct } from 'src/app/store/reducers';
import { MobileSelectorComponent } from './mobile-selector/mobile-selector.component';
import { BrandService } from '../../../../services/brand.service';
import { Observable } from 'rxjs';
import { CustomerAccount } from '@proximus/common-business-logic';
import { getProductMpcuidList, shouldRedirectToEshareUserJourney, constructEshareUrl } from '../../../util/overview-util';

const FAKE_PLC_PACK = 'PACK';

@Component({
  selector: 'mprd-add-new-product',
  templateUrl: './add-new-product.component.html',
})
export class AddNewProductComponent extends OnDestroyHookDirective {
  public ctaProducts: MultiLanguageLinkConfig[] = [];
  public taggingName: string;
  public isBelfiusPartner: boolean;
  public packId: string;
  public productId: string;
  public plcList = [];
  plc = '';
  internetProducts: MultiLanguageLinkConfig[] = [];
  mobileCtaProducts: MultiLanguageLinkConfig[] = [];
  tvProducts: MultiLanguageLinkConfig[] = [];
  deviceProducts: MultiLanguageLinkConfig[] = [];
  securityProducts: MultiLanguageLinkConfig[] = [];
  otherProducts: MultiLanguageLinkConfig[] = [];
  fixedLineProducts: MultiLanguageLinkConfig[] = [];
  packCtaProducts: MultiLanguageLinkConfig[] = [];
  eshareMpcuidDisallowlist = this.translationService.getTranslatedValueFor('products.addProduct.eshare.mpcuidDisallowlist');
  eshareSubscriptionParams = {
    mobileSubParam: {
      key: this.translationService.getTranslatedValueFor(
        'eshare.addMobileSubscribtion.key',
      ),
      url: this.translationService.getTranslatedValueFor(
        'eshare.addMobileSubscribtion.url',
      ),
    },
    internetSubParam: {
      key: this.translationService.getTranslatedValueFor(
        'eshare.addInternetSubscribtion.key',
      ),
      url: this.translationService.getTranslatedValueFor(
        'eshare.addInternetSubscribtion.url',
      ),
    },
    tvSubParam: {
      key: this.translationService.getTranslatedValueFor(
        'eshare.addTvSubscribtion.key',
      ),
      url: this.translationService.getTranslatedValueFor(
        'eshare.addTvSubscribtion.url',
      ),
    },
  };
  isScarlet: boolean;
  outOfPack: boolean;
  isFiberEligible: boolean;
  isEshareFiberEligible: boolean;
  isEshare1p2pEligible: boolean;
  eshareToken: string | undefined;
  eshare1p2pToken: string | undefined;
  intentFromEshare: string | undefined;
  lomIdFromEshare: string | undefined;
  mpcuidFromEshare: string | undefined;
  actionFromEshare: string | undefined;
  isComingFromIntent = false;
  dataForAddProduct: Pack;
  mobileProducts: Product[];
  installationAddresses: Record<string, Location> = {};
  customer$: Observable<CustomerAccount>;
  titleWithCustoumerName: string;
  redirectionToEshareEnabled: boolean;
  isLoading = false;

  constructor(
    private languageService: LanguageService,
    private translationService: TranslationService,
    private router: Router,
    private store: Store<ApplicationState>,
    private modalService: ModalService,
    private inceptionService: InceptionService,
    private brandService: BrandService,
    private customerService: CustomerService,
    private activatedRoute: ActivatedRoute,
    private readonly translateService: TranslationService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.redirectionToEshareEnabled = this.translateService.getTranslatedValueFor('products.addProduct.eshare.enable') === 'true';
    this.isLoading = this.redirectionToEshareEnabled;
    this.isComingFromIntent = !!this.activatedRoute.snapshot.params['category'];
    this.intentFromEshare = this.activatedRoute.snapshot.params['category'];
    this.lomIdFromEshare = this.activatedRoute.snapshot.queryParams['lomid'];
    this.mpcuidFromEshare = this.activatedRoute.snapshot.queryParams['mpcuid'];
    this.actionFromEshare = this.activatedRoute.snapshot.queryParams['action'];
    this.scrollToTop();
    const PIIObject = this.getPIIObject();
    this.isScarlet = this.brandService.isScarlet();
    this.outOfPack = PIIObject?.isOutOfPack;
    this.isEshare1p2pEligible = PIIObject?.isEshare1p2pEligible ?? false;
    this.isFiberEligible = PIIObject?.isFiberEligible ?? false;
    this.eshare1p2pToken = PIIObject?.eshare1p2pToken;
    if (PIIObject) {
      if (this.applyPIIObject(PIIObject)) {
        return;
      }
    }
    this.initializeProducts();

    const appBrand = this.translationService.getTranslatedValueFor('app.brand');
    this.store.dispatch(
      new ProductsActions.GetProducts({
        appBrand: appBrand ?? 'proximus',
      }),
    );
    this.addSubscription(
      this.store.select(getUserProduct).subscribe((data) => this.handleUserProductData(data, PIIObject)),
    );
    this.customer$ = this.customerService.getCustomerAccount();

    this.addSubscription(
      this.customer$.subscribe((customer) => this.handleCustomer(customer)),
    )
  }

  private applyPIIObject(PIIObject): boolean {
    if (this.doRedirectToEshareWhenEligible(PIIObject.productMpcuids, PIIObject.ewebToken)) {
      return true;
    }

    let productId;
    let plcList = undefined;
    if (this.outOfPack) {
      productId =
        PIIObject.plc == PlcCodes.FI ? PIIObject.productId : undefined;
      plcList =
        PIIObject.plc == PlcCodes.FI
          ? [PlcCodes.FI]
          : [PlcCodes.MV, PlcCodes.MI];
    } else {
      productId = PIIObject.productId;
    }

    this.ctaProducts = PIIObject.ctaProducts;
    this.productId = productId;
    this.packId = PIIObject.packId;
    this.taggingName = PIIObject.taggingName;
    this.isBelfiusPartner = PIIObject.isBelfiusPartner;
    this.plcList = plcList;
    this.plc = PIIObject.plc;
    return false;
  }

  private handleUserProductData(data, PIIObject): void {
    this.installationAddresses = data?.installationAddresses ?? {};
    if (
      !(
        data &&
        ((data.packs && data.packs.length > 0) ||
          (data.outOfPacks && data.outOfPacks.length > 0))
      )
    ) {
      return;
    }
    if (!PIIObject) {
      this.resolveSelectionFromData(data);
    }

    if (this.outOfPack) {
      this.dataForAddProduct = data.outOfPacks.filter((pack) => {
        return pack.coreProducts.find(
          (product) => product.productId === this.productId || !this.productId,
        );
      })[0];

      this.setEshareAttribute(PIIObject);
    } else {
      this.dataForAddProduct = data.packs.filter((product) => {
        return product.packId === this.packId;
      })[0];
    }

    const dataForAddProduct = this.outOfPack ? this.getOutOfPacksCtaProduct(this.dataForAddProduct) : this.dataForAddProduct;

    this.setCtaProducts(dataForAddProduct);

    this.mobileProducts = this.dataForAddProduct?.coreProducts?.filter(
      (product) => {
        return product.plc === PlcCodes.MV;
      },
    );

    this.doRedirectToEshareWhenEligible(getProductMpcuidList(dataForAddProduct), dataForAddProduct.ewebToken);
  }

  private resolveSelectionFromData(data): void {
    if (data.packs && data.packs.length === 1) {
      this.packId = data.packs[0].packId;
      this.outOfPack = false;
    } else if (
      data.outOfPacks?.length > 0 &&
      data.outOfPacks[0].coreProducts?.length > 0
    ) {
      this.productId = data.outOfPacks[0].coreProducts?.find((product) => product.ctaProducts)?.productId;
      this.outOfPack = true;
    } else {
      this.router.navigate(['/overview']);
    }
  }

  private handleCustomer(customer): void {
    if (customer) {
      this.titleWithCustoumerName = this.translationService.getTranslatedValueFor(
        'products.addProduct.titleName',
      )?.replace('{customerName}', customer.firstName);
    }
  }

  private setEshareAttribute(PIIObject) {
    if (!PIIObject?.isEshare1p2pEligible) {
      const product = this.getOutOfPacksCtaProduct(this.dataForAddProduct);
      this.isFiberEligible = product?.isFiberEligible;
      this.isEshare1p2pEligible = product?.isEshare1p2pEligible;
      this.eshare1p2pToken = product?.eshare1p2pToken;
    }
  }

  public getPIIObject() {
    return getPiiProduct();
  }

  public getOutOfPacksCtaProduct(outOfPack: any) {
    return outOfPack?.coreProducts?.find((product) => product.ctaProducts);
  }

  public getCtaProductLabel(ctaProduct: MultiLanguageLinkConfig): string {
    if (ctaProduct && ctaProduct.label) {
      return ctaProduct.label[this.languageService.getSelectedLanguage()];
    }
  }

  public getCtaProductTaggingName(ctaProduct: MultiLanguageLinkConfig): string {
    if (ctaProduct && ctaProduct.label) {
      return ctaProduct.label['en'];
    }
  }

  public goToMobileCta(ctaProduct: MultiLanguageLinkConfig): void {
    if (ctaProduct.eshareToken) {
      this.redirectEshareUrl(
        ctaProduct.url[this.languageService.getSelectedLanguage()] ||
        this.eshareSubscriptionParams.mobileSubParam.url,
        ctaProduct.eshareToken,
      );
      return;
    }

    const isEshareEnabled =
      this.translationService.getTranslatedValueFor(
        'eshare.oneToTwoP.intMob.enable',
      ) === 'true';

    if (
      isEshareEnabled &&
      this.isEshareUrl(
        ctaProduct,
        this.eshareSubscriptionParams.mobileSubParam.key,
      )
    ) {
      this.redirectEshareUrl(this.eshareSubscriptionParams.mobileSubParam.url);
    } else {
      this.goToCta(ctaProduct);
    }
  }

  public goToTvCta(ctaProduct: MultiLanguageLinkConfig): void {
    if (ctaProduct.eshareToken) {
      this.redirectEshareUrl(
        ctaProduct.url[this.languageService.getSelectedLanguage()] ||
        this.eshareSubscriptionParams.tvSubParam.url,
        ctaProduct.eshareToken,
      );
      return;
    }

    const isEshareEnabled =
      this.translationService.getTranslatedValueFor(
        'eshare.oneToTwoP.intTv.enable',
      ) === 'true';
    if (
      isEshareEnabled &&
      this.isEshareUrl(ctaProduct, this.eshareSubscriptionParams.tvSubParam.key)
    ) {
      this.redirectEshareUrl(this.eshareSubscriptionParams.tvSubParam.url);
    } else {
      this.goToCta(ctaProduct);
    }
  }

  public goToInternetCta(ctaProduct: MultiLanguageLinkConfig): void {
    if (ctaProduct.eshareToken) {
      this.redirectEshareUrl(
        ctaProduct.url[this.languageService.getSelectedLanguage()] ||
        this.eshareSubscriptionParams.internetSubParam.url,
        ctaProduct.eshareToken,
      );
      return;
    }

    const isEshareEnabled =
      this.translationService.getTranslatedValueFor(
        'eshare.oneToTwoP.mobInt.enable',
      ) === 'true';
    if (
      isEshareEnabled &&
      this.isEshareUrl(
        ctaProduct,
        this.eshareSubscriptionParams.internetSubParam.key,
      )
    ) {
      this.redirectEshareUrl(
        this.eshareSubscriptionParams.internetSubParam.url,
      );
    } else {
      this.goToCta(ctaProduct);
    }
  }

  public goToCta(ctaProduct: MultiLanguageLinkConfig): void {
    if (!ctaProduct) return;

    if (ctaProduct.eshareToken) {
      return this.redirectEshareUrl(ctaProduct.url[this.languageService.getSelectedLanguage()], ctaProduct.eshareToken);
    }

    if (ctaProduct.link && this.handlePlcCases(ctaProduct)) {
      this.handleLinkNavigation(ctaProduct);
    } else if (ctaProduct.url) {
      const urlWithFiberExtremeRedirectionOrigin = this.appendFiberExtremeRedirectionOrigin(ctaProduct.url[this.languageService.getSelectedLanguage()])
      window.open(
        urlWithFiberExtremeRedirectionOrigin,
        '_self',
      );
    }
  }

  private appendFiberExtremeRedirectionOrigin(url: string): string {
    if (url.includes('redirection_origin=fiber-extreme') || !this.intentFromEshare) {
      return url;
    }
    if (url.includes('?')) {
      return url + '&redirection_origin=fiber-extreme';
    }
    return url + '?redirection_origin=fiber-extreme';
  }

  private handleLinkNavigation(ctaProduct: MultiLanguageLinkConfig): void {
    const links = ctaProduct.link.split('#');

    if (links.length > 1) {
      if (this.intentFromEshare) {
        this.router.navigate(['/' + links[0]], { fragment: links[1], queryParams: { redirection_origin: 'fiber-extreme' }});
        return;
      }
      this.router.navigate(['/' + links[0]], { fragment: links[1]});
    } else {
      if (this.intentFromEshare) {
        this.router.navigate(['/' + ctaProduct.link], { queryParams: { redirection_origin: 'fiber-extreme'  }});
        return;
      }
      this.router.navigate(['/' + ctaProduct.link]);
    }
  }

  private handlePlcCases(ctaProduct: MultiLanguageLinkConfig): boolean {
    if (ctaProduct.plcs.includes(PlcCodes.MV.toString())) {
      if (this.mobileProducts?.length > 1) {
        this.openSelectMobileModal(ctaProduct.link);
        return false;
      } else {
        savePii(this.mobileProducts[0]?.accessNumber);
      }
    } else if (ctaProduct.plcs.includes(PlcCodes.NSP.toString())) {
      savePiiNsp({
        packId: this.packId,
        productId: this.productId,
        plcList: this.plcList,
      });
    } else if (ctaProduct.plcs.includes(PlcCodes.TV.toString())) {
      savePii(
        this.dataForAddProduct.coreProducts.filter((product) => {
          return product.plc === PlcCodes.TV;
        })[0]?.accessNumber,
      );
    } else if (ctaProduct.plcs.includes(PlcCodes.FI.toString())) {
      savePii(
        this.dataForAddProduct.coreProducts.filter((product) => {
          return product.plc === PlcCodes.FI;
        })[0]?.accessNumber,
      );
    }

    return true;
  }

  public getCtaProductIcons(ctaProduct: MultiLanguageLinkConfig): string[] {
    let icons: string[] = [];
    if (ctaProduct && ctaProduct.plcs) {
      for (const plcs of ctaProduct.plcs) {
        icons = icons.concat(this.getPlcsIcon(plcs));
      }
    }
    return icons;
  }

  private setCtaProducts(pack: any): void {
    if (this.ctaProducts.length === 0) {
      this.ctaProducts = pack.ctaProducts;
      this.initializeProducts();
    }
  }

  private initializeProducts(): void {
    this.fillInternetProducts();
    this.fillDeviceProducts();
    this.fillFixedLineProducts();
    this.fillMobileProducts();
    this.fillOthersProducts();
    this.fillTvProducts();
    this.fillSecurityProducts();
    this.fillPackProducts();
  }

  private getPlcsIcon(plcs) {
    switch (plcs) {
      case PlcCodes.FI:
        return 'icon-Internet';
      case PlcCodes.MV:
        return 'icon-Mobile';
      case PlcCodes.FT:
        return 'icon-Telephony';
      case PlcCodes.INS:
      case PlcCodes.NSP:
      case PlcCodes.SEC:
        return 'icon-Norton-security';
      case PlcCodes.TV:
        return 'icon-Television';
      case PlcCodes.DV:
        return 'icon-Devices';
      default:
        break;
    }
  }

  fillInternetProducts() {
    this.internetProducts = this.ctaProducts.filter((product) => {
      if (product.plcs.length === 1) {
        return product.plcs[0] == PlcCodes.FI.toString();
      }
    });
  }

  fillFixedLineProducts() {
    this.fixedLineProducts = this.ctaProducts.filter((product) => {
      if (product.plcs.length === 1) {
        return product.plcs[0] == PlcCodes.FT.toString();
      }
    });
  }

  fillMobileProducts() {
    this.mobileCtaProducts = this.ctaProducts.filter((product) => {
      if (product.plcs.length === 1) {
        return product.plcs[0] == PlcCodes.MV.toString();
      }
    });
  }

  fillTvProducts() {
    this.tvProducts = this.ctaProducts.filter((product) => {
      if (product.plcs.length === 1) {
        return product.plcs[0] == PlcCodes.TV.toString();
      }
    });
  }

  fillSecurityProducts() {
    this.securityProducts = this.ctaProducts.filter((product) => {
      if (product.plcs.length === 1) {
        return (
          product.plcs[0] == PlcCodes.NSP.toString() ||
          product.plcs[0] === PlcCodes.SEC.toString()
        );
      }
    });
  }

  fillDeviceProducts() {
    this.deviceProducts = this.ctaProducts.filter((product) => {
      if (product.plcs.length === 1) {
        return product.plcs[0] == PlcCodes.DV.toString();
      }
    });
  }

  fillOthersProducts() {
    this.otherProducts = this.ctaProducts.filter((product) => {
      return product.plcs.length !== 1;
    });
  }

  fillPackProducts(): void {
    this.packCtaProducts = this.ctaProducts.filter((product) => {
      return product.plcs.length && product.plcs[0] === FAKE_PLC_PACK;
    });
  }

  isEshareUrl(
    ctaProduct: MultiLanguageLinkConfig,
    subscriptionKey: string,
  ): boolean {
    return !!(
      this.isEshare1p2pEligible &&
      this.plc &&
      !ctaProduct.plcs.includes(this.plc) &&
      ctaProduct?.url?.en?.includes(subscriptionKey)
    );
  }

  openSelectMobileModal(link) {
    this.modalService
      .create<MobileSelectorComponent>(MobileSelectorComponent)
      .subscribe((componentRef: ComponentRef<MobileSelectorComponent>) => {
        componentRef.instance.mobileProducts = this.mobileProducts;
        componentRef.instance.link = link;
      });
  }

  redirectToContact() {
    let link;
    if (this.isBelfiusPartner) {
      link = 'products.addProduct.hero.belfiusLink.url';
    } else {
      link = 'products.addProduct.hero.link.url';
    }
    window.open(this.translationService.getTranslatedValueFor(link), '_self');
  }

  private scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#addProduct');
    });
  }

  private constructUrl(url: string, token: string) {
    return constructEshareUrl(url, token, {
      intent: this.intentFromEshare,
      lomid: this.lomIdFromEshare,
      mpcuid: this.mpcuidFromEshare,
      action: this.actionFromEshare
    });
  }

  private redirectEshareUrl(url: string, token?: string) {
    window.open(this.constructUrl(url, token), '_self');
    return;
  }

  private doRedirectToEshareWhenEligible(productMpcUuids: string[], token: string): boolean {
    if (this.redirectionToEshareEnabled && shouldRedirectToEshareUserJourney(productMpcUuids, this.eshareMpcuidDisallowlist)) {
      const url = this.translationService.getTranslatedValueFor('products.addProduct.eshare.url');
      if (url && token) {
        this.redirectEshareUrl(url, token);
        return true;
      }
    }

    this.isLoading = false;
    return false;
  }
}
